import { action, observable } from 'mobx';
import { TokenAssignmentType } from '~client/model/token-assignment-type';
import { BaseStore } from '~web/store/base/base-store';

export class TokenAssignmentFlowStore extends BaseStore {
  @observable optionsOverlayShown: boolean;
  @observable removeGuestModalShown: boolean;
  @observable tokenAssignmentType: TokenAssignmentType;

  constructor() {
    super();
    this.clear();
  }

  @action
  showOptionsOverlay(): void {
    this.optionsOverlayShown = true;
  }

  @action
  hideOptionsOverlay(): void {
    this.optionsOverlayShown = false;
  }

  @action
  setTokenAssignmentType(type: TokenAssignmentType): void {
    this.tokenAssignmentType = type;
  }

  @action
  showRemoveGuestModal(): void {
    this.removeGuestModalShown = true;
  }

  @action
  hideRemoveGuestModal(): void {
    this.removeGuestModalShown = false;
  }

  clear(): void {
    this.optionsOverlayShown = false;
    this.tokenAssignmentType = undefined;
    this.removeGuestModalShown = false;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/web/src/js/store/token/token-assignment-flow-store.ts